/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerResendMutationResponse, InvitationsControllerResendPathParams, InvitationsControllerResend400, InvitationsControllerResend401, InvitationsControllerResend403, InvitationsControllerResend404 } from "../../models/invitationsController/InvitationsControllerResend";

function getInvitationsControllerResendUrl(id: InvitationsControllerResendPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/invitations/${id}/resend` as const }  
  return res
}

/**
 * @description Resends the Trimble invitation email and renews the invitation expiry.
 * @summary Resend invitation
 * {@link /api/v1/invitations/:id/resend}
 */
export async function invitationsControllerResend(id: InvitationsControllerResendPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<InvitationsControllerResendMutationResponse, ResponseErrorConfig<InvitationsControllerResend400 | InvitationsControllerResend401 | InvitationsControllerResend403 | InvitationsControllerResend404>, unknown>({ method : "POST", url : getInvitationsControllerResendUrl(id).url.toString(), ... requestConfig })  
  return res.data
}